import React from 'react'
import Header from '../components/Header'
import { Footer } from '../components/SharedLayout'
import OctoberFeaturedSection from '../components/sections/OctoberFeaturedSection'

const ProductPage: React.FC = () => {
  const heading = 'rgb(15,15,15)'
  const sub = 'rgb(76,76,75)'

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24 sm:pt-28 pb-16">
        {/* Hero Section */}
        <section className="py-16">
          <div className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{ color: heading }}>
              Complete Product & Pricing Information
            </h1>
            <p className="text-xl max-w-3xl mx-auto" style={{ color: sub }}>
              Detailed pricing breakdown, service packages, and all the information you need about our full maintenance membership and home maintenance membership.
            </p>
          </div>
        </section>

        {/* October Featured Service */}
        <OctoberFeaturedSection />

        {/* Pricing lives only on Pricing page */}
        <section className="py-12 text-center">
          <p className="text-lg mb-4" style={{ color: sub }}>Plans and pricing are on our Pricing page.</p>
          <a href="/pricing" className="inline-block px-6 py-3 rounded-full font-semibold text-white" style={{ backgroundColor: '#145F6B' }}>View pricing</a>
        </section>

        {/* Additional Information */}
        <section className="py-16 bg-gray-50">
          <div className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-4" style={{ color: heading }}>
                Why Choose Hudson My Home?
              </h2>
              <p className="text-lg" style={{ color: sub }}>
                Our full maintenance membership and home maintenance membership ensure your property is always in perfect condition.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">🏠</span>
                </div>
                <h3 className="text-xl font-semibold mb-3" style={{ color: heading }}>
                  Proactive Maintenance
                </h3>
                <p className="text-sm" style={{ color: sub }}>
                  Prevent costly repairs with our comprehensive monthly maintenance program covering over 100 annual tasks.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">👨‍🔧</span>
                </div>
                <h3 className="text-xl font-semibold mb-3" style={{ color: heading }}>
                  Dedicated Technicians
                </h3>
                <p className="text-sm" style={{ color: sub }}>
                  Work with the same trusted Hudson technician who knows your home inside and out.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl">📱</span>
                </div>
                <h3 className="text-xl font-semibold mb-3" style={{ color: heading }}>
                  Digital Management
                </h3>
                <p className="text-sm" style={{ color: sub }}>
                  Access your MyHome Vault™ and Blueprint™ for complete transparency and home management insights.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}

export default ProductPage
